<template>
  <div class="form-category">
    <div>
      <v-dialog v-model="npaReportDialog" max-width="900">
        <v-card class="modal npa-report-modal">
          <div class="modal-head">
            {{ $t("Отчет онлайн обсуждения проекта НПА") }}
            <v-btn color="modal-close" :aria-label="$t('Закрыть')" @click.native="dialogLocal = false">
              <span class="pro-icon-close1" aria-hidden="true"></span>
            </v-btn>
          </div>
          <div class="modal-body">
            <v-simple-table>
              <tbody>
              <tr>
                <td>{{ $t('Дата публикации') }}:</td>
                <td>{{ new Date(npa.npa.publish_date) | dateFormat('DD.MM.YYYY') }}</td>
              </tr>
              <tr v-if="npa.npa.is_shortened">
                <td>{{ $t('Доп.мероприятия') }}:</td>
                <td>{{npa.npa.extra_measures}}</td>
              </tr>
              <tr>
                <td>{{ $t('Срок общественного обсуждения') }}:</td>
                <td>{{ $t('до {date}', { date: dateDiscussStep }) }}</td>
              </tr>
              <tr>
                <td>{{ $t('Количество просмотров') }}:</td>
                <td>{{ npa.npa.view_number }}</td>
              </tr>
              <tr>
                <td>{{ $t('Количество комментариев') }}:</td>
                <td>{{ npa.commentsCnt }}</td>
              </tr>
              <tr>
                <td>{{ $t('Количество ответов на комментарии') }}:</td>
                <td>{{ npa.answersCnt }}</td>
              </tr>
              <tr>
                <td>{{ $t('Количество просроченных ответов на комментарии') }}:</td>
                <td>{{ npa.overdueAnswersCount }}</td>
              </tr>
              <tr>
                <td>{{ $t('Количество учтенных комментариев') }}:</td>
                <td>{{ npa.commentsTaken }}</td>
              </tr>
              <tr>
                <td>{{ $t('Количество частично учтенных комментариев') }}:</td>
                <td>{{ npa.commentsPartTaken }}</td>
              </tr>
              <tr>
                <td>{{ $t('Количество неучтенных комментариев') }}:</td>
                <td>{{ npa.commentsNotTaken }}</td>
              </tr>
              <tr>
                <td>{{ $t('Всего голосов "за" комментарии') }}:</td>
                <td>{{ npa.commentsLike }}</td>
              </tr>
              <tr>
                <td>{{ $t('Всего голосов "против" комментарии') }}:</td>
                <td>{{ npa.commentsDislike }}</td>
              </tr>
              </tbody>
            </v-simple-table>
            <a
              class="print-report-btn"
              role="button"
              tabindex="0"
              @click="printPdf"
              @keyup.enter="printPdf"
              @keyup.space="printPdf"
            >{{ $t("Скачать отчет") }}</a>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex'
  import Npa from '@/model/npa'

  export default {
    props: {
      npa: Object,
      npaReportDialog: Boolean,
      dateDiscussStep: String
    },
    computed: {
      dialogLocal: {
        get() {
          return this.npaReportDialog
        },
        set(dialog) {
          this.$emit('update:npaReportDialog', dialog)
        }
      }
    },
    methods: {
      ...mapMutations(['setLoading']),
      // печать в ворд
      printPdf () {
        this.setLoading(true)
        Npa.pdfPrint(this.$route.params.id)
          .then((res) => {
            this.forceFileDownload(res)
          })
          .catch(() => {
            this.$noty.warning(this.$i18n.t('Error'), {
              killer: true,
              timeout: 1000,
              layout: 'topRight'
            })
          })
        this.setLoading(false)
      },
      // генерация ссылки для скачивания pdf файла
      forceFileDownload (res) {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `report_npa_${this.npa.npa.id}.pdf`)
        document.body.appendChild(link)
        link.click()
      }
    }
  }
</script>

<style scoped>
.npa-report-modal .modal-head {
  background: #004581;
  color: #fff;
  font-weight: 500;
  box-shadow: inset 0 -1px 0 rgba(255, 255, 255, .18);
}

.npa-report-modal .modal-head .v-btn {
  color: #fff;
}

.npa-report-modal .modal-head .v-btn:hover {
  background-color: rgba(255, 255, 255, .12);
}
</style>
